<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type BadgeVariants, badgeVariants } from '.'
import { cn } from '@/lib/utils'

const props = defineProps<{
  variant?: BadgeVariants['variant']
  class?: HTMLAttributes['class']
  label?: string
  icon?: string
  iconClass?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn(badgeVariants({ variant }), props.class)">
    <Icon
      v-if="icon"
      :name="icon"
      class="mr-1"
      :class="iconClass"
    />
    <slot>
      <span v-if="label">
        {{ label }}
      </span>
    </slot>
  </div>
</template>
